/* global Parsley _: true */

// Additional parslet validators

Parsley.addValidator('invalid', {
  validateString: function (value) {
    return true;
  },
  messages: {
    en: 'Error occurred.',
    th: 'มีข้อผิดพลาดเกิดขึ้น'
  }
});

Parsley.addValidator('duplicate', {
  validateString: function (value) {
    return true;
  },
  messages: {
    en: 'Value already exists',
    th: 'ไม่สามารถใช้ค่านี้ได้'
  }
});

Parsley.addValidator('password', {
  validateString: function (value) {
    if (/[^a-zA-Z0-9.,-=/\|!@#$%^&*()_+]/.test(value)) {
      return false;
    }
    return true;
  },
  messages: {
    en: 'a-z, A-Z, 0-9 or .,-=/\\|!@#$%^&*()_+ are allowed',
    th: 'เป็น a-z, A-Z, 0-9 หรือ .,-=/\\|!@#$%^&*()_+ เท่านั้น'
  }
});

Parsley.addValidator('match', {
  validateString: function (value, matchInputId, parsleyInstance) {
    if (matchInputId) {
      const matchingElement = _.find(
        parsleyInstance.parent.fields,
        field => field.element.id === matchInputId
      );
      if (matchingElement && value !== matchingElement.value) {
        return false;
      }
    }
    return true;
  },
  messages: {
    en: 'Password is mismatch',
    th: 'รหัสผ่านไม่ตรงกัน'
  }
});

Parsley.addValidator('mobilephone', {
  validateString: function (value) {
    return /^[0][0-9]{2}-?[0-9]{3}-?[0-9]{4}$/.test(value);
  },
  messages: {
    en: 'Enter mobile phone number without space or -',
    th: 'ใส่เบอร์โทรศัพท์มือถือติดกัน ไม่ต้องใส่ - หรือเว้นวรรค'
  }
});
